import {HelperFunctions} from "./helperFunctions";

/*
* @desc Override will hijack a method allowing to extend the functionality of it and then execute it
*/
export function doOverrideShoptetFunctions() {
    if (shoptet.checkout && shoptet.checkout.gopaySelectHelper) {
        const origGoPayMethod = shoptet.checkout.gopaySelectHelper;
        shoptet.checkout.gopaySelectHelper = (...args) => {
            HelperFunctions.showSelectedShippingCart();
            origGoPayMethod(...args);
        };
    }
}
/*
* @desc Overwrite will replace a method allowing to extend the functionality of it and then execute it
*/
export function doOverwriteShoptetFunctions() {}


